import styled from "styled-components";

import { Text } from "@ui/Atoms";
import { Star as StarIcon } from "@ui/Assets/MyIcons";

export const Root = styled.div`
  color: ${({ theme }) => theme.palette.grey900};
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.border.radius.base};
  padding: ${({ theme }) => theme.spacing.spacing_16};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  height: 100%;
  user-select: none;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    padding: ${({ theme }) => theme.spacing.spacing_24};
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    padding: ${({ theme }) => theme.spacing.spacing_32};
  }
`;

export const StarsDateContainer = styled(Text).attrs({
  $style: "regular_12",
})`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_4};
  align-items: center;
`;

export const Stars = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_2};
`;

export const Title = styled(Text).attrs({
  $style: {
    default: "semibold_18",
    smallDesktop: "semibold_20",
  },
})``;

export const Feedback = styled(Text).attrs({
  $style: {
    default: "regular_16",
    smallDesktop: "regular_18",
  },
})``;

export const Authour = styled(Text).attrs({
  $style: "regular_12",
  $color: "grey600",
})``;

export const Star = styled(StarIcon).attrs(({ theme }) => ({
  width: theme.icons.sizes.base_x2,
}))`
  stroke: ${({ theme }) => theme.palette.yellow500};
  fill: ${({ theme }) => theme.palette.yellow500};
`;
